import { Component, useContext, useEffect, useRef } from "react";
import Metismenu from "metismenujs";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useHistory } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { Badge } from "react-bootstrap";
import { toast } from "react-toastify";

import { ThemeContext } from "../../../context/ThemeContext";
import { ROUTE } from "../../../constants/app_routes";
import notiSound from "../../../assets/sounds/noti.wav";
import SocketClient from "../../../services/SocketClient";
import { SOCKET_CLIENT } from "../../../constants/socket";
import {
  useQueryAllNotifications,
  useQueryCurrentUser,
} from "../../../graphql/apollo/query-hooks";
import { ADMIN_POSITION } from "../../../constants/app_constants";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {}
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const { history } = useHistory();
  const { currentUser } = useQueryCurrentUser();
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }, []);
  const scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  const { allChatNotifications, refetch } = useQueryAllNotifications();

  const audioRef = useRef(null);
  const playSound = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  const showToast = () => {
    toast.info("ຂໍ້ຄວາມໃໝ່", {
      autoClose: 10000,
      onClick: () => {
        history.push(ROUTE.chat);
      },
    });
  };

  const callNotification = () => {
    refetch();
    playSound();
    showToast();
  };

  useEffect(() => {
    SocketClient.on(SOCKET_CLIENT.RECIEVE_MESSAGE, (data) => {
      if (currentUser?.branch) {
        if (currentUser?.branch?.id == data?.branch?.id) {
          callNotification();
        }
      } else {
        if (data?.branch == undefined) {
          callNotification();
        }
      }
    });
  }, [refetch]);

  const isSuperAdminOrHeadBranch =
    currentUser?.isSuperAdmin ||
    currentUser?.position == ADMIN_POSITION.BRANCH_HEAD;

  return (
    <>
      <audio ref={audioRef} src={notiSound} />
      <div
        className={`dlabnav ${iconHover} ${
          sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
            ? scrollPosition > 120
              ? "fixed"
              : ""
            : ""
        }`}
      >
        <PerfectScrollbar className="dlabnav-scroll lao">
          <MM className="metismenu" id="menu">
            <li className={`${ROUTE.dashboard === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.dashboard} className="ai-icon">
                <i className="fas fa-user-check"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>
            {currentUser?.isSuperAdmin && (
              <li className={`${ROUTE.branch === path ? "mm-active" : ""}`}>
                <Link to={ROUTE.branch} className="ai-icon">
                  <i className="fas fa-flag"></i>
                  <span className="nav-text">ຈຸສາຂາ</span>
                </Link>
              </li>
            )}

            <li className={`${ROUTE.country === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.country} className="ai-icon">
                <i className="fas fa-flag"></i>
                <span className="nav-text">ປະເທດ</span>
              </Link>
            </li>
            <li className={`${ROUTE.room === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.room} className="ai-icon">
                <i className="fas fa-cube"></i>
                <span className="nav-text">ຫ້ອງເກມ</span>
              </Link>
            </li>
            <li className={`${ROUTE.chat === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.chat} className="ai-icon">
                <i className="fas fa-envelope"></i>
                <span className="nav-text ">ແຊດ</span>
                {allChatNotifications > 0 ? (
                  <Badge bg="danger" className="message-badge">
                    {allChatNotifications}
                  </Badge>
                ) : null}
              </Link>
            </li>
            <li className={`${ROUTE.bet === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.bet} className="ai-icon">
                <i className="fas fa-dice-d6"></i>
                <span className="nav-text">ລາຍການເດີມພັນ</span>
              </Link>
            </li>
            <li className={`${ROUTE.bet_option === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.bet_option} className="ai-icon">
                <i className="fas fa-gamepad"></i>
                <span className="nav-text">ຈັດການຂໍ້ມູນເດີມພັນ</span>
              </Link>
            </li>
            {/* <li className={`${ROUTE.staff === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.staff} className="ai-icon">
                <i className="fas fa-users"></i>
                <span className="nav-text">ຈັດການຂໍ້ມູນພະນັກງານ</span>
              </Link>
            </li> */}
            <li className={`${ROUTE.member === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.member} className="ai-icon">
                <i className="fas fa-user-check"></i>
                <span className="nav-text">ສະມາຊິກ</span>
              </Link>
            </li>
            {isSuperAdminOrHeadBranch && (
              <li className={`${ROUTE.admin === path ? "mm-active" : ""}`}>
                <Link to={ROUTE.admin} className="ai-icon">
                  <i className="fas fa-users"></i>
                  <span className="nav-text">ຈັດການແອດມິນ</span>
                </Link>
              </li>
            )}
            {/* 
            <li className={`${ROUTE.bot === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.bot} className="ai-icon">
                <i className="fas fa-user-check"></i>
                <span className="nav-text">ຈັດການບັອດ</span>
              </Link>
            </li> */}
            <li className={`${ROUTE.transaction === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.transaction} className="ai-icon">
                <i className="fas fa-list"></i>
                <span className="nav-text">ລາຍການທຸລະກຳ</span>
              </Link>
            </li>
            <li className={`${ROUTE.topup === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.topup} className="ai-icon">
                <i className="fas fa-money-bill"></i>
                <span className="nav-text">ຕື່ມເງິນ</span>
              </Link>
            </li>
            <li className={`${ROUTE.deposit === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.deposit} className="ai-icon">
                <i className="fas fa-money-check"></i>
                <span className="nav-text">ຝາກປະຈຳ</span>
              </Link>
            </li>
            <li
              className={`${ROUTE.digitalWallet === path ? "mm-active" : ""}`}
            >
              <Link to={ROUTE.digitalWallet} className="ai-icon">
                <i className="fas fa-money-check"></i>
                <span className="nav-text">Digital Wallet</span>
              </Link>
            </li>
            <li className={`${ROUTE.withdraw === path ? "mm-active" : ""}`}>
              <Link to={ROUTE.withdraw} className="ai-icon">
                <i className="fas fa-money-check"></i>
                <span className="nav-text">ຖອນເງິນ</span>
              </Link>
            </li>
            {currentUser?.isSuperAdmin && (
              <li className={`${ROUTE.setting === path ? "mm-active" : ""}`}>
                <Link to={ROUTE.setting} className="ai-icon">
                  <i className="fas fa-cog"></i>
                  <span className="nav-text">ຕັ້ງຄ່າ</span>
                </Link>
              </li>
            )}
          </MM>
        </PerfectScrollbar>
      </div>
    </>
  );
};

export default SideBar;
